module.exports = __webpack_public_path__ + "static/img/partners2.61d1750.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/partners2.jpg?0219
// module id = Jag/
// module chunks = 0